import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as translations from '.';
var localeToTranslations = {
  'cs-CZ': translations.cs,
  'da-DK': translations.da,
  'de-DE': translations.de,
  'en-US': translations.en,
  'en-GB': translations.en_GB,
  'en-ZZ': translations.en_ZZ,
  'es-ES': translations.es,
  'fi-FI': translations.fi,
  'fr-FR': translations.fr,
  'hu-HU': translations.hu,
  'it-IT': translations.it,
  'ja-JP': translations.ja,
  'ko-KR': translations.ko,
  'no-NO': translations.nb,
  'nl-NL': translations.nl,
  'pl-PL': translations.pl,
  'pt-BR': translations.pt_BR,
  'ru-RU': translations.ru,
  'sv-SE': translations.sv,
  'tr-TR': translations.tr,
  'th-TH': translations.th,
  'uk-UA': translations.uk,
  'vi-VN': translations.vi,
  'zh-TW': translations.zh_TW,
  'zh-CN': translations.zh
};
var fetchTranslations = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    var _localeToTranslations;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", (_localeToTranslations = localeToTranslations[locale]) !== null && _localeToTranslations !== void 0 ? _localeToTranslations : translations.en);
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchTranslations(_x) {
    return _ref.apply(this, arguments);
  };
}();
export default fetchTranslations;